export const defaultTransformWrapperConfig = {
    doubleClick: { disabled: true },
    maxScale: 20,
    wheel: { smoothStep: 0.001 },
};

export const ROTATION_DIRECTION = Object.freeze({ CLOCKWISE: 'CW', COUNTERCLOCKWISE: 'CCW' });
